import React from 'react';
import PropTypes from 'prop-types';

import { H2, Paragraph } from 'components/core/Typography';
import { Section, Group } from 'components/core/Page';
import { Link } from 'components/core/Link';

export function Post({ post }) {
	// Strip out all the WP Garbage
	const content = post.text.replace('<p>', '').substring(0, post.text.length);
	return (
		<div className="blog-post">
			<Paragraph size="small">
				<Link
					target="_blank"
					hideBorder
					rel="noopener noreferrer"
					href={post.link}
				>
					{post.title}
				</Link>
			</Paragraph>
			<div>
				<Paragraph className="post-content">
					<span
						dangerouslySetInnerHTML={{ __html: content }} // eslint-disable-line react/no-danger
					/>
				</Paragraph>
				<Link
					target="_blank"
					rel="noopener noreferrer"
					className="read-more"
					href={post.link}
				>
					Read more
				</Link>
			</div>
		</div>
	);
}

Post.propTypes = {
	post: PropTypes.shape({
		title: PropTypes.string,
		text: PropTypes.string,
		link: PropTypes.string,
	}).isRequired,
};

export default function BlogPosts({ headerText, posts }) {
	return (
		<Section>
			<div>
				<Group>
					<H2
						className="sf-type-large blog-posts-header"
						weight="ultraBold"
					>
						{headerText}
					</H2>
				</Group>
				{posts.map((post, index) => (
					<Group key={post.date || index}>
						<Post post={post} />
					</Group>
				))}
			</div>
		</Section>
	);
}

BlogPosts.propTypes = {
	headerText: PropTypes.string.isRequired,
	posts: PropTypes.arrayOf(Post.propTypes.post).isRequired,
};
